import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { hasPermission } from '../utils/permission';
import withAuth from './withAuth';
import { useSelector } from 'react-redux';

/**
 * HOC that allows to check auth user permissions agains the `requiredPermissions` prop.
 * The component will only be rendered if the auth user has the right permissions.
 */
const withAuthPermission = () =>
    withAuth(
        ({
            path = null,
            auth,
            requiredPermissions = [],
            noAuthRedirect = true,
            requireClientHQEnabled = false,
            children,
        }) => {
            const currentUser = useSelector((state) => state.session.user);
            const hasAuthPermission = useCallback(() => {
                return hasPermission(auth.authorities || [], requiredPermissions);
            }, [auth.authorities, requiredPermissions]);

            const renderNoAuthComponent = () => (noAuthRedirect ? <Navigate to="/access-denied" /> : null);

            useEffect(() => {
                if (!hasAuthPermission()) {
                    //enqueueSnackbar('You have no permission to access this page', { variant: 'error' });
                }
            }, [hasAuthPermission]);

            // Client HQ check
            if (requireClientHQEnabled && !currentUser.isClientHqEnabled) {
                return renderNoAuthComponent();
            }

            if (hasAuthPermission()) {
                return children;
            }

            return renderNoAuthComponent();
        },
    );

withAuthPermission.propTypes = {
    /**
     * Array of required permissions the auth user needs to have to access the component
     */
    requiredPermissions: PropTypes.arrayOf(PropTypes.string),

    /**
     * Redirect the user if unauthorized
     */
    noAuthRedirect: PropTypes.bool,
};

withAuthPermission.defaultProps = {
    requiredPermissions: [],
    noAuthRedirect: true,
};

export default withAuthPermission;
